import * as amplitude from '@amplitude/analytics-browser';
import { onCLS, onFCP, onINP, onLCP, onTTFB } from 'web-vitals';

type Metric = {
  name: string;
  value: number;
  id: string;
  delta: number;
  rating: 'good' | 'needs-improvement' | 'poor';
};

function sendToAnalytics(metric: Metric) {
  amplitude.track(metric.name, metric);
}

export function logWebVitalMetric(metric: Metric) {
  sendToAnalytics(metric);
}

export function reportWebVitals() {
  onCLS(logWebVitalMetric);
  onLCP(logWebVitalMetric);
  onTTFB(logWebVitalMetric);
  onINP(logWebVitalMetric);
  onFCP(logWebVitalMetric);
}
